import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Progress, Skeleton } from 'antd';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import css from './TrackProgress.module.scss';

const TrackProgress = ({ finishedTopics, totalTopics, className = '', loading }) => {
  const { t } = useTranslation('TrackCard');

  const statPercent = useMemo(() => Math.round((finishedTopics / totalTopics) * 100), [finishedTopics, totalTopics]);

  return (
    <div className={classNames(css['TrackProgress'], className)}>
      {loading ? (
        <Skeleton paragraph={{ rows: 1 }} title={false} />
      ) : (
        <>
          <Progress percent={statPercent} showInfo={false} />
          <div className={css['TrackProgress-text']}>
            <div>{t('finished', { total: statPercent || 0 })}</div>
            <div>
              {finishedTopics}/{totalTopics}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

TrackProgress.propTypes = {
  finishedTopics: PropTypes.number,
  totalTopics: PropTypes.number,
  className: PropTypes.string,
  loading: PropTypes.bool,
};

export default TrackProgress;
